import api from 'service/api'

const guestPortalAPI = api.create('guestPortal')

const get = async () => guestPortalAPI.get('/profile')

const update = async (data) =>
  guestPortalAPI.put('/profile', { guestUser: data })

export default { get, update }
